export { ClientRouteOptions } from "@cervval.js/client-routes/src/clientRoutes.service";
export { TypedClientAjaxProxy } from "@cervval.js/client-routes/src/typedClientAjaxProxy.decorator";